import HttpResponse from "../../../../utils/http/http.response";

export enum DriverPotentialPlanResponsePlanEntryType {
  RESTRICTED = "RESTRICTED",
  FULL = "FULL",
}

export type DriverPotentialPlanResponseRestrictedPlanEntryStartNodeMeta = {
  estimatedTime: string;
  id: string;
};

export type DriverPotentialPlanResponseRestrictedPlanEntryStartNode = {
  displayName: string;
  time: string | null;
  haltingTime: number | null;
  meta: DriverPotentialPlanResponseRestrictedPlanEntryStartNodeMeta;
};

export type DriverPotentialPlanResponseRestrictedPlanEntryEndNodeMeta = {
  estimatedTime: string;
  id: string;
};

export type DriverPotentialPlanResponseRestrictedPlanEntryEndNode = {
  displayName: string;
  time: string | null;
  haltingTime: number | null;
  meta: DriverPotentialPlanResponseRestrictedPlanEntryEndNodeMeta;
};

export type DriverPotentialPlanResponseRestrictedPlanEntry = {
  id: string;
  humanId: number;
  viewType: DriverPotentialPlanResponsePlanEntryType.RESTRICTED;
  startNode: DriverPotentialPlanResponseRestrictedPlanEntryStartNode;
  endNode: DriverPotentialPlanResponseRestrictedPlanEntryEndNode;
};

export type DriverPotentialPlanResponseFullPlanEntryStartNodeMeta = {
  estimatedTime: string;
  id: string;
};

export type DriverPotentialPlanResponseFullPlanEntryStartNode = {
  displayName: string;
  time: string | null;
  haltingTime: number | null;
  meta: DriverPotentialPlanResponseFullPlanEntryStartNodeMeta;
};

export type DriverPotentialPlanResponseFullPlanEntryEndNodeMeta = {
  estimatedTime: string;
  id: string;
};

export type DriverPotentialPlanResponseFullPlanEntryEndNode = {
  displayName: string;
  time: string | null;
  haltingTime: number | null;
  meta: DriverPotentialPlanResponseFullPlanEntryEndNodeMeta;
};

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrderRideSeqMeta = {
  estimatedTime: string;
  id: string;
};

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrderRideSeq = {
  displayName: string;
  time: string | null;
  haltingTime: number | null;
  meta: DriverPotentialPlanResponseFullPlanEntrySolvedOrderRideSeqMeta;
};

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrderRide = {
  seq: DriverPotentialPlanResponseFullPlanEntrySolvedOrderRideSeq[];
};

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrderTransportingOrder =
  {
    cargoOrder: DriverPotentialPlanResponseFullPlanEntrySolvedOrderTransportingOrderCargoOrder;
  };

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrderTransportingOrderCargoOrder =
  {
    humanId: number;
  };

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrderCargoCompany = {
  displayName: string;
};

export type DriverPotentialPlanResponseFullPlanEntrySolvedOrder = {
  ride: DriverPotentialPlanResponseFullPlanEntrySolvedOrderRide;
  transportingOrder: DriverPotentialPlanResponseFullPlanEntrySolvedOrderTransportingOrder;
  cargoCompany: DriverPotentialPlanResponseFullPlanEntrySolvedOrderCargoCompany;
};

export type DriverPotentialPlanResponseFullPlanEntry = {
  id: string;
  humanId: number | null;
  viewType: DriverPotentialPlanResponsePlanEntryType.FULL;
  startNode: DriverPotentialPlanResponseFullPlanEntryStartNode;
  endNode: DriverPotentialPlanResponseFullPlanEntryEndNode;
  solvedOrders: DriverPotentialPlanResponseFullPlanEntrySolvedOrder[];
};

export type DriverPotentialPlanResponsePlanEntry =
  | DriverPotentialPlanResponseRestrictedPlanEntry
  | DriverPotentialPlanResponseFullPlanEntry;

type DriverPotentialPlanResponseData = {
  entries: DriverPotentialPlanResponsePlanEntry[];
};

type DriverPotentialPlanResponse =
  HttpResponse<DriverPotentialPlanResponseData>;

export default DriverPotentialPlanResponse;
